import { __makeTemplateObject } from "tslib";
import React from 'react';
import styled from 'styled-components';
import { gridSize } from '@atlaskit/theme/constants';
import { Label } from './styled/Field';
var FieldsetLabel = styled(Label)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 0;\n"], ["\n  margin-bottom: 0;\n"])));
var Fieldset = styled.fieldset(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: ", "px;\n"], ["\n  margin-top: ", "px;\n"])), gridSize);
export default (function (_a) {
    var children = _a.children, legend = _a.legend;
    return (React.createElement(Fieldset, null,
        legend && (React.createElement("legend", null,
            React.createElement(FieldsetLabel, null, legend))),
        children));
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=Fieldset.js.map